import type { Ref } from "react";

export const assignRef = <T>(ref: Ref<T> | undefined, node: T | null) => {
	if (typeof ref === "function") ref(node);
	else if (ref) ref.current = node;
};
